import { render, staticRenderFns } from "./App.vue?vue&type=template&id=caf96ab4&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf96ab4",
  null
  
)

export default component.exports